module.exports = __webpack_public_path__ + "images/emoji/fishing_pole_and_fish.e4d627980aee3cfd7a88.png";